module.exports = __webpack_public_path__ + "static/media/filled.2bcf1c4d.jpg";